export const GET_CHAT_MESSAGES_REQUEST = 'USER_GET_CHAT_MESSAGES_REQUEST';
export const GET_CHAT_MESSAGES_SUCCESS = 'USER_GET_CHAT_MESSAGES_SUCCESS';
export const GET_CHAT_MESSAGES_FAILURE = 'USER_GET_CHAT_MESSAGES_FAILURE';

export const POST_MESSAGE_TO_CHAT_REQUEST = 'USER_POST_MESSAGE_TO_CHAT_REQUEST';
export const POST_MESSAGE_TO_CHAT_SUCCESS = 'USER_POST_MESSAGE_TO_CHAT_SUCCESS';
export const POST_MESSAGE_TO_CHAT_FAILURE = 'USER_POST_MESSAGE_TO_CHAT_FAILURE';

export const ADD_MESSAGE = 'USER_ADD_MESSAGE';
export const RESET_SCROLL_TO_BOTTOM = 'USER_RESET_SCROLL_TO_BOTTOM';
export const RESET_CHAT = 'USER_RESET_CHAT';
export const RELOAD_MESSAGES = 'USER_RELOAD_MESSAGES';
